import React, { useEffect, useMemo, useState } from "react";

import { Col, FormGroup, Row, Spinner } from "reactstrap";
import DataTable from "../../shared/base-components/DataTable";
import { filtersTypes } from "./Console.constants";
import SelectBox from "../../shared/base-components/SelectBox";
import { useConsoleListMutation } from "./Console.actions";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import useCookie from "../../shared/hooks/useCookie";
import paths from "../../shared/route/paths";
import { formatDateString } from "../../shared/utils/formatText";

const ConsoleList = () => {
  document.title =
    "Alınacak Ücretler | Bu ekranda alınacak ücretli listesini görebilirsiniz.";
  const [_, setCookieCustomerProfileId] = useCookie("customerProfileId");

  const { control } = useForm();

  const [selectedFilter, setSelectedFilter] = useState<any>(0);

  const { data, mutate, isLoading } = useConsoleListMutation();

  const columns = useMemo(
    () => [
      {
        Header: "Düzenleme",
        filterable: false,
        disableFilters: true,
        accessor: "fullname",
        Cell: (response: any) => (
          <>
            <h5 className="font-size-14 mb-1">
              <Link
                onClick={() =>
                  setCookieCustomerProfileId(
                    response.row.original?.customer.id,
                    90
                  )
                }
                to={
                  response.row.original?.content_type === 1 || 2
                    ? paths.CUSTOMER.CUSTORMER_PROFILE
                    : paths.EXPENSE
                }
                className="text-dark"
              >
                {response.row.original?.content}
              </Link>
            </h5>
          </>
        ),
      },
      {
        Header: "Düzenleme Tarihi",
        filterable: false,
        disableFilters: true,
        accessor: "created_at",
        Cell: (response: any) => (
          <>
            <h5 className="font-size-14 mb-1">
              {formatDateString(response.row.original?.created_at)}
            </h5>
          </>
        ),
      },
    ],
    []
  );

  useEffect(() => {
    mutate(selectedFilter);
  }, [selectedFilter]);

  return (
    <React.Fragment>
      <Row className="align-items-center">
        <Col md={6}>
          <div className="mb-3">
            <h5 className="card-title">
              Son Düzenlemeler Listesi
              <span className="text-muted fw-normal ms-2">
                {isLoading ? (
                  <Spinner className="ms-1" color="primary" />
                ) : (
                  `(${data?.results.length})`
                )}
              </span>
            </h5>
          </div>
        </Col>

        <Col md={6}>
          <div className="d-flex flex-wrap align-items-center justify-content-end gap-2 mb-3">
            <div>
              <ul className="nav nav-pills"></ul>
            </div>
            <div></div>
          </div>
        </Col>
      </Row>

      <Row className="align-items-center">
        <div className={"mt-4 pt-2 text-muted"}>
          <FormGroup className="mb-3">
            <Col sm="12" md="4" lg="4">
              <SelectBox
                control={control}
                name="devicePart"
                className="form-control"
                onChangeHandler={(e) =>
                  setSelectedFilter(parseInt(e.target.value))
                }
                options={filtersTypes}
              />
            </Col>
          </FormGroup>
        </div>
      </Row>

      <Row>
        <Col lg="12">
          {data?.results?.length && (
            <DataTable
              columns={columns}
              data={data.results}
              isGlobalFilter={true}
              isAddUserList={true}
              customPageSize={10}
              className="table align-middle datatable dt-responsive table-check nowrap"
            />
          )}
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default ConsoleList;
